export default "__VITE_ASSET__97718240__"